import React from 'react';
import Typography from 'new/elements/Typography';
import { useForm } from 'new/elements/Form/useForm';
import cx from 'classnames';
import { ReactComponent as Check } from 'new/elements/Form/assets/check.svg';

import classes from './StepsForm.module.scss';

export type StepItemType = {
  name: string;
  index: number;
  clickable?: boolean;
  status: 'active' | 'done' | 'next';
};

export const StepItem = ({ name, index, status, clickable }: StepItemType) => {
  const { setActivePage } = useForm();
  const onClickStep = () => {
    if (status === 'done' && clickable) {
      setActivePage(index);
    }
  };

  return (
    <div className={cx(classes.stepContainer, classes['stepContainer_' + status])}>
      <button className={classes.step} onClick={onClickStep}>
        <div className={classes.indexWrapper}>
          {status === 'done' ? <Check /> : <span>{index + 1}</span>}
        </div>
        <Typography>{name}</Typography>
      </button>
    </div>
  );
};

StepItem.getStatus = (activePage: number, index: number) => {
  if (activePage === index) return 'active';
  if (activePage < index) return 'next';
  return 'done';
};

const Steps = () => {
  const { activePage, steps } = useForm();
  return (
    <div className={classes.steps}>
      {steps.map((step) => {
        const status = StepItem.getStatus(activePage, step.index);
        const stepKey = `step_${step.index}`;
        return (
          <StepItem
            key={stepKey}
            index={step.index}
            name={step.name}
            status={status}
            clickable={step?.clickable}
          />
        );
      })}
    </div>
  );
};

type StepsFormComponentProps = {
  LeftView?: React.ReactNode;
  containerClassName?: string;
  activePage: number;
  steps: StepItemType[];
};

export const StepsForm = (props: StepsFormComponentProps) => {
  const { LeftView, containerClassName, activePage, steps } = props;

  if (!steps || !steps.length || activePage < steps[0].index) {
    return null;
  }

  return (
    <div className={cx(classes.stepsSection, containerClassName)}>
      <div className={classes.left}>
        {LeftView}
        <Steps />
      </div>
    </div>
  );
};
